export class UserGroupMetricsModel {
    public totalUserGroups: number;
    public activeUserGroups: number;
}
